import { Suspense, lazy, Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Route, Routes, useLocation } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import UtilComponent from "./UtilComponent";
import checkIfAppReady from "../helpers/checkIfAppReady";
import LoadingFullPage from "../components/common/Loading/LoadingFullPage";
import DashBoardRoutes from "./DashBoardRoutes";
import { updateNetworkStatus } from "../redux/action/networkStatusAction";
import { getOfflineUser } from "../redux/action/offlineDataActions";
import getoffiledata from "../helpers/readOfflineData";

const Login = lazy(() => import("../pages/Login"));
const ExpiredSubscription = lazy(() => import("../pages/ExpiredSubscription"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword"));
const TermsAndConditions = lazy(() => import("../pages/TermsAndConditions"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const RefundPolicy = lazy(() => import("../pages/RefundPolicy"));
const ContactUs = lazy(() => import("../pages/ContactUs"));


const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const HomeRoutes = () => {
  const ready = checkIfAppReady();

  const dispatch = useDispatch();
  const { isOnline, isAppOffline } = useSelector(
    (state) => state.networkStatus,
  );

  useEffect(() => {
    const handleOnline = () => {
      dispatch(updateNetworkStatus(true));
    };

    const initializeOfflineData = async () => {
      if (window?.api?.isElectron && (isAppOffline || !isOnline)) {
        dispatch(getOfflineUser(await getoffiledata("user")));
      }
    };
    initializeOfflineData();

    const handleOffline = () => {
      dispatch(updateNetworkStatus(false));
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [dispatch]);

  return ready ? (
    <Fragment>
      <UtilComponent />
      <ScrollToTop />
      <Suspense fallback={<LoadingFullPage />}><Routes>
        <Route path="/expired" element={<ExpiredSubscription />} />

        <Route path="/login" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />

        {/* Dashboard Routes handles its own sub-routes */}
        <Route
          path="/*"
          element={<ProtectedRoute component={DashBoardRoutes} />}
        />
      </Routes></Suspense>
    </Fragment>
  ) : (
    <LoadingFullPage />
  );
};
export default HomeRoutes;
